import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'

import type { FormValues } from '../AnalyticsTrackingPixels.types'
import { useUpdateShopAnalyticsMutation } from '../queries/updateShopAnalyticsMutation'

export const useAnalyticsTrackingPixels = () => {
  const { currentShop, invalidateCurrentShopQuery } = useCurrentShop()
  const { updateShopAnalyticsMutation } = useUpdateShopAnalyticsMutation()

  const initialValues = {
    googleAnalyticsTrackingId: currentShop?.settings.analytics?.googleAnalyticsTrackingId || '',
    facebookPixelId: currentShop?.settings.analytics?.facebookPixelId || '',
    tiktokPixelId: currentShop?.settings.analytics?.tiktokPixelId || '',
  }

  const handleSubmit = async (values: FormValues) => {
    await updateShopAnalyticsMutation.mutateAsync(
      [
        { shopId: currentShop?.id! },
        {
          googleAnalyticsTrackingId: values.googleAnalyticsTrackingId.trim() || undefined,
          facebookPixelId: values.facebookPixelId.trim() || undefined,
          tiktokPixelId: values.tiktokPixelId.trim() || undefined,
        },
      ],
      {
        onSuccess: () => {
          invalidateCurrentShopQuery()
        },
      },
    )
  }

  return {
    initialValues,
    onSubmit: handleSubmit,
  }
}
